module.exports = __webpack_public_path__ + "img/zs8.cb4a3b7a.jpg";